export default {
  SET_INVENTARIO_TABLE_HEADERS(state, payload) {
    state.inventarioTableHeaders = payload;
  },
  SET_INVENTARIO_TABLE_ITEMS(state, payload) {
    state.inventarioTableItems = payload;
  },
  SET_PRECISAO_INVENTARIO(state, payload) {
    state.precisaoInventario = payload;
  },
  SET_INVENTARIOS_REALIZADOS(state, payload) {
    state.inventariosRealizados = payload;
  },
  SET_HISTORICO_PRODUTOS_INVENTARIO(state, payload) {
    state.historicoProdutosInventario = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
